<template>
  <portal to="global-modal-portal" v-if="isLocationModalActive">
    <b-modal :active.sync="isLocationModalActive" :width="640" scroll="keep" :has-modal-card="true" :canCancel="false">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Location</p>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column has-text-left">
              <p>For legal reasons your current location is required. Please enable location services for this site and click the verify location button below to proceed. Check out the Geolocation helper section below for more info.</p>
            </div>
          </div>
          <div class="columns">
            <div class="column has-text-left">
              <h3>Geolocation Helper Information</h3>
              <p><a href="https://www.wikihow.com/Enable-Location-Services-on-Google-Chrome" target="_blank" class="list-group-item">How to enable Location Services in Google Chrome</a></p>
              <p><a href="https://yandex.com/support/common/browsers-settings/geo-firefox.html" target="_blank" class="list-group-item">How to enable Location Services in Mozilla Firefox</a></p>
              <p><a href="https://yandex.com/support/common/browsers-settings/geo-ie.html" target="_blank" class="list-group-item">How to enable Location Services in Internet Explorer</a></p>
              <p><a href="https://yandex.com/support/common/browsers-settings/geo-opera.html" target="_blank" class="list-group-item">How to enable Location Services in Opera</a></p>
              <p><a href="https://yandex.com/support/common/browsers-settings/geo-safari.html" target="_blank" class="list-group-item">How to enable Location Services in Safari</a></p>
              <p><a href="https://tileteam.zendesk.com/hc/en-us/articles/217069598-How-to-Turn-Location-On-or-Off-with-your-phone-or-tablet-" target="_blank" class="list-group-item">How to enable Location Services on a mobile device</a></p>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-info" @click="closeLocation">Ok</button>
        </footer>
      </div>
    </b-modal>
  </portal>
</template>

<script>

export default {
  name: 'LocationControl',
  components: {
  },
  props: {
    showLocationModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLocationModalActive: false,
      instanceId: this.$uuid.v4()
    }
  },
  methods: {
    closeLocation () {
      this.isLocationModalActive = false
    }
  },
  watch: {
    showLocationModal: function (newValue, oldValue) {
      if (newValue) {
        this.isLocationModalActive = true
      }
    }
  },
  mounted: function () {
    this.isLocationModalActive = this.showLocationModal
  }
}

</script>

<style scoped>
  .modal-card-head, .modal-card-foot {
    padding: 20px !important
  }

  .modal-card-body {
    max-height: 500px !important;
    min-height: 500px !important;
    height: 500px !important;
  }
</style>
